import { FORM_FIELDS } from '../consts';

export const achOutMandatoryForm = () => [
  {
    type: 'single',
    inputType: 'text',
    maxLen: 17,
    name: 'MANAGE_VENDOR.FORM.ACH_ACCOUNT',
    replaceValueScheme: /\D/g,
    requiredMessage: 'ACH Account Number is required',
    validateScheme: /^[0-9]{5,17}$/,
    validateErrorMessage: 'Please enter a valid ACH Account Number',
    inputId: FORM_FIELDS.ACH_ACCOUNT_NUMBER,
    shouldValidateOnClick: true,
  },
  {
    type: 'single',
    inputType: 'text',
    maxLen: 9,
    name: 'MANAGE_VENDOR.FORM.ACH_ROUTE',
    replaceValueScheme: /\D/g,
    requiredMessage: 'ACH Routing Number is required',
    validateScheme: /^[0-9]{9}$/,
    validateErrorMessage: 'Please enter a valid ACH Routing Number',
    inputId: FORM_FIELDS.ACH_ROUTING_NUMBER,
    shouldValidateOnClick: true,
  },
];
